/**
 *
 * SurgeryTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { MedicalServiceIcon } from 'assets/v2/icons';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.budGreenDark};
    background: ${COLORS.budGreenLight};
    border-color: ${COLORS.budGreen};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.budGreen};
    }
  }
`;

function SurgeryTag(props) {
  return (
    <StyledTag label="Accepted" icon={<MedicalServiceIcon />} {...props} />
  );
}

export default memo(SurgeryTag);
